// AppRoutes.js
import React from 'react';
import { useRoutes } from 'react-router-dom';
import Login from './screen/Login';
// import Dashboard from './screen/Dashboard';
import DashboardMap from './screen/DashboardMap';

const AppRoutes = () => {
  const routes = [
    { path: '/', element: <Login /> },
    // { path: '/dashboard', element: <Dashboard /> },
    { path: '/dashboardMap', element: <DashboardMap /> },
    // Add more routes as needed
  ];

  return useRoutes(routes);
};

export default AppRoutes;
